import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      dark: {
        primary: '#1ea5be',
        secondary: '#4caf50',
        tertiary: '#495057',
        accent: '#82B1FF',
        error: '#1e69be',
        info: '#00d3ee',
        success: '#1ebe8b',
        warning: '#ffa21a',
        gray: '#252525',
        neutral: '#ffffff'
      }
    }
  },
  icons: {
    iconfont: 'mdi'
  }
})
